/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { LaunchDarklyError } from "./launchdarklyerror.js";

export type StatusConflictErrorRepData = {
  /**
   * Specific error code encountered
   */
  code: string;
  /**
   * Description of the error
   */
  message: string;
};

export class StatusConflictErrorRep extends LaunchDarklyError {
  /**
   * Specific error code encountered
   */
  code: string;

  /** The original data that was passed to this error instance. */
  data$: StatusConflictErrorRepData;

  constructor(
    err: StatusConflictErrorRepData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    this.code = err.code;

    this.name = "StatusConflictErrorRep";
  }
}

/** @internal */
export const StatusConflictErrorRep$inboundSchema: z.ZodType<
  StatusConflictErrorRep,
  z.ZodTypeDef,
  unknown
> = z.object({
  code: z.string(),
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new StatusConflictErrorRep(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type StatusConflictErrorRep$Outbound = {
  code: string;
  message: string;
};

/** @internal */
export const StatusConflictErrorRep$outboundSchema: z.ZodType<
  StatusConflictErrorRep$Outbound,
  z.ZodTypeDef,
  StatusConflictErrorRep
> = z.instanceof(StatusConflictErrorRep)
  .transform(v => v.data$)
  .pipe(z.object({
    code: z.string(),
    message: z.string(),
  }));
